import { ButtonWithIcon } from '@oy/uidesktop';
import { Link } from 'react-router-dom';
import { useTranslate } from 'src/hooks';

const BulkDisbursementActionButton = () => {
  const { getTranslation } = useTranslate();

  return (
    <Link to={'/settings/bulk-receipt'}>
      <ButtonWithIcon
        iconName="settings"
        style={{ backgroundColor: 'transparent' }}
        color={ButtonWithIcon.Color.Secondary}
        buttonType={ButtonWithIcon.Type.Outlined}
      >
        {getTranslation('common_settings')}
      </ButtonWithIcon>
    </Link>
  );
};

export default BulkDisbursementActionButton;
